import React from "react";
import ReactDOM from "react-dom/client";
import App from "./App";
import "@fontsource/opendyslexic/400.css";
import "@fontsource/opendyslexic/700.css";
import "./index.css";
import i18n, { prepareInitialLanguage } from "./lib/i18n";
import { initOfflineMode } from "./lib/offline/register-sw";
import { clearStaleAuthTokenCookie } from "./lib/auth-bootstrap";
import { exposeClearLanguageForDev, exposeSimplifiedTextCacheCommand } from "./lib/clear-language-for-testing";
import { installChunkLoadRecovery } from "./lib/chunk-load-recovery";

clearStaleAuthTokenCookie();
exposeClearLanguageForDev();
exposeSimplifiedTextCacheCommand();
installChunkLoadRecovery();
// Mode hors ligne des élèves : service worker (production) + synchronisation de la progression en attente.
initOfflineMode(() => i18n.language || "fr");

// Accessibilité : axe-core tourne uniquement en mode dev (logs DOM dans la console).
// `__LYRRA_DEV__` est défini dans vite.config.ts → esbuild remplace puis DCE en prod.
declare const __LYRRA_DEV__: boolean;
if (__LYRRA_DEV__) {
  void import("./lib/dev/axe-bootstrap").then(({ startAxe }) => startAxe(React, ReactDOM));
}

function renderApp() {
  ReactDOM.createRoot(document.getElementById("root")!).render(
    <React.StrictMode>
      <App />
    </React.StrictMode>
  );
}

// Langue mémorisée hors fr / en (ex. arabe) : attendre son bundle pour éviter un premier écran en anglais.
// Délai maximal de 8 s en bas débit ; au-delà l'application s'affiche et la langue s'applique dès son arrivée.
void Promise.race([
  prepareInitialLanguage(),
  new Promise((resolve) => window.setTimeout(resolve, 8000)),
]).finally(renderApp);
